import { config } from '../config/environment'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let initialized = false

export function getGaMeasurementId(): string {
  return config.analytics.measurementId
}

/** REACT_APP_GA_MEASUREMENT_ID 가 있을 때만 gtag.js 로드 */
export function initGoogleAnalytics(): void {
  const measurementId = getGaMeasurementId()
  if (!measurementId || typeof window === 'undefined' || initialized) return

  initialized = true
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args)
  }
  window.gtag('js', new Date())
  window.gtag('config', measurementId)

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)
}
